import Collection from '../../utils/Collection';

import {
  FETCH_MY_PRONUNCIATION_STATUSES_SENT,
  FETCH_MY_PRONUNCIATION_STATUSES_SUCCEEDED,
} from '../../actions/pronunciation';

const initialState = {
  statuses: [],
  loaded: false, // This is useful for studentDashboard
  loading: false,
};

export default function pronunciationReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_MY_PRONUNCIATION_STATUSES_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_MY_PRONUNCIATION_STATUSES_SUCCEEDED:
      return {
        ...state,
        statuses: Collection.reset(
          state.statuses,
          payload.pronunciation_statuses,
        ),
        loaded: true,
        loading: false,
      };
    default:
      return state;
  }
}
